export default{
  userInfo: {
    roleIds: [],
    headImgUrl: '',
    nickName: ''
  },
  show: false // footer组件内使用
}
